import http from "@/utils/http";

export default {
  /**
   * Get unread announcements
   */
  getUnreadAnnouncements() {
    return http.get("/announcements/unread");
  },

  /**
   * Get all announcements
   */
  getAnnouncements() {
    return http.get("/announcements");
  },

  /**
   * Get unread announcements count
   */
  getUnreadCount() {
    return http.get("/announcements/unread-count");
  },

  /**
   * Get announcement detail
   */
  getAnnouncement(id) {
    return http.get(`/announcements/${id}`);
  },

  /**
   * Delete an announcement (Secret Admin only).
   */
  deleteAnnouncement(id) {
    return http.delete(`/admin/announcements/${id}`);
  },

  /**
   * Mark announcements as read
   */
  readAnnouncements(ids) {
    return http.post("/announcements/read", {
      announcement_ids: ids
    });
  },

  /**
   * Issue a signed URL for uploading an attachment directly to GCS (Admin).
   */
  issueUploadUrl({ filename, mimeType, size }) {
    return http.post("/admin/announcements/upload-url", {
      filename,
      mime_type: mimeType,
      size
    });
  },

  /**
   * Upload a file directly to GCS using the pre-signed PUT URL.
   * 純粋なネイティブfetchでバイナリを送る。axios のデフォルトヘッダや
   * interceptor の影響を避け、CORS preflight を最小化する。
   */
  async uploadToGcs(uploadUrl, file) {
    const res = await fetch(uploadUrl, {
      method: "PUT",
      body: file
    });
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`GCS upload failed: ${res.status} ${text}`);
    }
    return res;
  },

  /**
   * Post new announcement (Admin). Attachment must already be uploaded to GCS.
   */
  postAnnouncement({ title, body, attachmentGcsPath }) {
    return http.post("/admin/announcements", {
      title,
      body,
      attachment_gcs_path: attachmentGcsPath
    });
  }
};
